import { ReportListItemData } from './report-base';

export class DiscountReportUserListData extends ReportListItemData {
  discountCode: string;
  reason: string;
  discountAmount: number;
  discountUsedDate: Date;
}

export class DiscountReport {
  totalNumberOfDiscount: number;
  totalDiscountAmount: number;
  list: DiscountReportUserListData[];

  constructor(data: any = {}) {
    this.totalNumberOfDiscount = +data.totalNumberOfDiscount;
    this.totalDiscountAmount = +data.totalDiscountAmount;
    this.list = data.discountReportUserList ? data.discountReportUserList.map(l => new DiscountReportUserListData(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/discount-report.ts